import { Injectable } from '@angular/core';
import { Router, Route, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad } from '@angular/router';
import { ConfigService } from '../config.service';
import { AuthService } from './auth.service';

@Injectable()
export class ExpiredGuard implements CanActivate, CanLoad {
    constructor(private _auth: AuthService, private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.isExpired();
    }

    public canLoad(route: Route): Promise<boolean> {
        return this.isExpired();
    }

    isExpired(): Promise<boolean> {
        return new Promise(resolve => {
            if (!this._auth.passwordExpired) {
                if (ConfigService.app.oauthExternal) {
                    this.router.navigate(['/loginExternal']);
                } else {
                    this.router.navigate(['/login']);
                }
            }
            resolve(this._auth.passwordExpired);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/expired.guard.ts